import 'css-chunk:../components/modal/index.module.scss';export default {
  "backdrop": "_backdrop_bwkdx_1",
  "wrapper": "_wrapper_bwkdx_7",
  "modal": "_modal_bwkdx_19",
  "footer": "_footer_bwkdx_46",
  "small": "_small_bwkdx_51",
  "narrow": "_narrow_bwkdx_55",
  "narrower": "_narrower_bwkdx_59",
  "extra_narrow": "_extra_narrow_bwkdx_63",
  "wider": "_wider_bwkdx_67",
  "body": "_body_bwkdx_71"
};